import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    section: {
      margin: theme.spacing(2)
    },
    sectionContent: {
      paddingTop: 0
    },
    loading: {
      marginTop: theme.spacing(10)
    },
    storeSelect: {
      display: "flex",
      justifyContent: "center",
      margin: theme.spacing(2)
    },
    deadlinePassed: {
      color: "red"
    }
  })
);
